import { useEffect } from 'react';
import { VIEWBOX } from '../constants';

type ZoomLevel = 'fit' | '0.5' | '1';

interface ZoomControlsProps {
  zoom: ZoomLevel;
  onZoom: (z: ZoomLevel) => void;
  svgRef: React.RefObject<SVGSVGElement | null>;
}

export default function ZoomControls({ zoom, onZoom, svgRef }: ZoomControlsProps) {
  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;
    if (zoom === 'fit') {
      svg.style.width = '100%'; svg.style.height = 'auto'; svg.style.maxWidth = '100%';
    } else {
      const s = parseFloat(zoom);
      svg.style.width = `${VIEWBOX.width * s}px`;
      svg.style.height = `${VIEWBOX.height * s}px`;
      svg.style.maxWidth = 'none';
    }
  }, [zoom, svgRef]);

  useEffect(() => {
    function onResize() {
      if (zoom === 'fit') onZoom('fit');
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [zoom, onZoom]);

  return (
    <span className="zoomset" role="group" aria-label="Zoom level">
      <span className="zlbl">Zoom</span>
      <button className={`zbtn${zoom === 'fit' ? ' on' : ''}`} onClick={() => onZoom('fit')}>Fit</button>
      <button className={`zbtn${zoom === '0.5' ? ' on' : ''}`} onClick={() => onZoom('0.5')}>50%</button>
      <button className={`zbtn${zoom === '1' ? ' on' : ''}`} onClick={() => onZoom('1')}>100%</button>
    </span>
  );
}
